export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdWrh25MsukHfsF87D9AlqRiBlBrjMCrcMjl5UWkIFwUOSL3Q/viewform?usp=publish-editor";
